// Copyright (c) 2021 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getShippingInventoryLocations () {

    const endPoint = `${basePath}/inventory-locations/type/calendar`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function getFactoryDayStatus ( start, end ) {

    const endPoint = `${basePath}/factory-day-status`;
    const payLoad = {
        startDate: start,
        endDate: end
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getShippingDayStatus ( start, end, inventory ) {

    const endPoint = `${basePath}/shipping-day-status`;
    const payLoad = {
        startDate: start,
        endDate: end,
        inventory
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function postFactoryDayStatus ( month, year, details ) {

    const endPoint = `${basePath}/factory-calendar-insert`;
    const payLoad = {
        month,
        year,
        calendardetails: details
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function postShippingDayStatus ( month, year, inventory, details ) {

    const endPoint = `${basePath}/shipping-calendar-insert`;
    const payLoad = {
        month,
        year,
        inventory,
        calendardetails: details
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
